module.exports = {
	"config": {
		"siteTitle": "AKINGO",
		"linkPrefix": "/de/akingo"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_content.js",
				"ext": "js",
				"name": "_content",
				"extname": ".js",
				"basename": "_content.js",
				"dirname": "",
				"stem": "_content",
				"path": "_content.js"
			},
			"requirePath": "_content.js",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_mainPage.jsx",
				"ext": "jsx",
				"name": "_mainPage",
				"extname": ".jsx",
				"basename": "_mainPage.jsx",
				"dirname": "",
				"stem": "_mainPage",
				"path": "_mainPage.jsx"
			},
			"requirePath": "_mainPage.jsx",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js"
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 401
// module chunks = 0